import styled from 'styled-components'

import { colors } from '../../../../../constants'

export const GreenDot = styled.div`
    border: 5px solid ${colors.green};
    border-radius: 50%;
    box-shadow: -1px -1px #fff, 1px 1px #fff, 1px -1px #fff, -1px 1px #fff;
    display: inline-block;
    height: 0;
    margin-right: 5px;
    width: 0;
`

export const RedDot = styled.div`
    border: 5px solid ${colors.red};
    border-radius: 50%;
    box-shadow: -1px -1px #fff, 1px 1px #fff, 1px -1px #fff, -1px 1px #fff;
    display: inline-block;
    height: 0;
    margin-right: 5px;
    width: 0;
`

export const YellowDot = styled.div`
    border: 5px solid ${colors.orange};
    border-radius: 50%;
    box-shadow: -1px -1px #fff, 1px 1px #fff, 1px -1px #fff, -1px 1px #fff;
    display: inline-block;
    height: 0;
    margin-right: 5px;
    width: 0;
`
export const GreyDot = styled.div`
    border: 5px solid ${colors.grey};
    border-radius: 50%;
    box-shadow: -1px -1px #fff, 1px 1px #fff, 1px -1px #fff, -1px 1px #fff;
    display: inline-block;
    height: 0;
    margin-right: 5px;
    width: 0;
`
